// Owner: platform-agent. While the member looks at a planned change in the app (features/copilot/
// preview-mode.ts), every API read carries the preview's id: the server answers it from inside the plan's
// uncommitted transaction (apps/api/src/core/preview.ts). Kept apart from the preview mode so the API client
// does not depend on a feature.
export const PREVIEW_HEADER = 'x-dataroom-preview';

let current: string | null = null;
let onEnded: (() => void) | null = null;

/** Called when the server says the preview is over (it expired, or the API restarted). */
export function onPreviewEnded(fn: (() => void) | null): void {
  onEnded = fn;
}

export function setPreviewHeader(id: string | null): void {
  current = id;
}

export function previewHeader(): string | null {
  return current;
}

/** `fetch` that adds the preview header while a preview is shown. */
export const previewFetch: typeof fetch = (input, init) => {
  const id = current;
  if (!id) return globalThis.fetch(input, init);
  const headers = new Headers(init?.headers);
  headers.set(PREVIEW_HEADER, id);
  return globalThis.fetch(input, { ...init, headers }).then((res) => {
    if (res.status === 410 && current === id) onEnded?.();
    return res;
  });
};
